/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OAuthEnablementMetadata = {
  /**
   * Count of security variables that are OAuth2 supported
   */
  oauth2SecurityCount: number;
};

/** @internal */
export const OAuthEnablementMetadata$inboundSchema: z.ZodMiniType<
  OAuthEnablementMetadata,
  unknown
> = z.pipe(
  z.object({
    oauth2_security_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "oauth2_security_count": "oauth2SecurityCount",
    });
  }),
);

export function oAuthEnablementMetadataFromJSON(
  jsonString: string,
): SafeParseResult<OAuthEnablementMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OAuthEnablementMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OAuthEnablementMetadata' from JSON`,
  );
}
